export default __webpack_public_path__ + "static/media/icon-image.a5792705.svg";